import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';

/**
 * TP2020-11188 — the single entry point for Amplify.configure() in this app.
 *
 * Cognito tokens are stored host-only on this subdomain via CookieStorage. After aws-amplify 6.17.0
 * (verified on 6.22.2), every Amplify.configure() call resets the singleton token
 * provider's storage back to localStorage, so a pool switch (login/forgot/reset
 * pages) would otherwise write the session to localStorage and the next full page
 * load would find no tokens in the cookie jar and bounce to /login. Re-apply the
 * cookie storage after every configure.
 */
export function configureAmplify(config: Parameters<typeof Amplify.configure>[0]): void {
    Amplify.configure(config);

    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    const secure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ domain: host, secure, sameSite: 'lax', expires: 30 }));
}
